import type { Dayjs } from "dayjs";
import type { DashboardLatestRide } from "./queries/reports";
import type { VoucherType } from "./queries/voucherTypes";

const RIDE_AGGREGATION_WINDOW_MS = 60_000;

export interface AggregatedRide {
  id: string;
  voucher_id: string;
  customer_name: string;
  voucher_type?: VoucherType | null;
  cancelled: boolean;
  time: Dayjs;
  count: number;
}

// aggregateLatestRides collapses rapid repeat rides of the same voucher
// (within RIDE_AGGREGATION_WINDOW_MS) into a single row with a count.
// Input must be sorted created_at DESC (as returned by the server).
export function aggregateLatestRides(rides: DashboardLatestRide[]): AggregatedRide[] {
  const result: AggregatedRide[] = [];

  for (const ride of rides) {
    const last = result[result.length - 1];
    if (
      last &&
      last.voucher_id === ride.voucher_id &&
      last.cancelled === ride.cancelled &&
      Math.abs(last.time.diff(ride.created_at)) <= RIDE_AGGREGATION_WINDOW_MS
    ) {
      last.count++;
    } else {
      result.push({
        id: ride.id,
        voucher_id: ride.voucher_id,
        customer_name: ride.customer_name,
        voucher_type: ride.voucher_type,
        cancelled: ride.cancelled,
        time: ride.created_at,
        count: 1,
      });
    }
  }

  return result;
}
